import { useEffect } from 'react';
import triggerWootricSurvey from 'ContentEditorUI/utils/triggerWootricSurvey';
import { useSelector } from 'react-redux';
import { getIsUngatedForWootricCsatSurvey } from '../redux/selectors/authSelectors';
export const WootricSurveyNames = {
  PAGES_EDITOR: 'LPSP_EDITOR',
  BLOG_EDITOR: 'BLOG_EDITOR',
  GLOBAL_CONTENT_EDITOR: 'GLOBAL_EDITOR',
  EMBEDS_EDITOR: 'EMBEDS_EDITOR'
};
const TriggerWootricCsatSurvey = ({
  surveyName
}) => {
  const isUngatedForWootricCsatSurvey = useSelector(getIsUngatedForWootricCsatSurvey);
  useEffect(() => {
    if (isUngatedForWootricCsatSurvey) {
      triggerWootricSurvey(surveyName);
    }
  }, [isUngatedForWootricCsatSurvey, surveyName]);
  return null;
};
export default TriggerWootricCsatSurvey;